import React, { useRef, useEffect } from 'react';
import Add from '../Components/Add';
import Category from '../Components/Category';
import EndAdd from '../Components/EndAdd';
import HomeCard from '../Components/HomeCard';
import HomeCard1 from '../Components/HomeCard1';
import HomeCard2 from '../Components/HomeCard2';
import HomeCard3 from '../Components/HomeCard3';
import HomeCard4 from '../Components/HomeCard4';
import HomeCard5 from '../Components/HomeCard5';
import HomeCard6 from '../Components/HomeCard6';
import HomeCard7 from '../Components/HomeCard7';
import HomeCard8 from '../Components/HomCard8';
import HomeCard9 from '../Components/HomeCard9';
import HomeCard10 from '../Components/HomeCard10';
import HomeCardPro from '../Components/HomeCardPro';
import BannerAdd from '../Components/BannerAdd';

export default function Home({ setIsLoading }) {
  const categoryRefs = {
    Mobile: useRef(null),
    Car: useRef(null),
    Property: useRef(null),
    Bikes: useRef(null),
    Jobs: useRef(null),
    Hostels: useRef(null),
    Electronics: useRef(null),
    Furniture: useRef(null),
  };

  const scrollToCategory = (category) => {
    const ref = categoryRefs[category];
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

const AdsterraBannerPC = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (window.innerWidth >= 768 && containerRef.current) {
      const script1 = document.createElement('script');
      script1.innerHTML = `
        atOptions = {
          'key': '9e8bb6172a4ce815606ae5e98c86e78b',
          'format': 'iframe',
          'height': 90,
          'width': 728,
          'params': {}
        };
      `;
      const script2 = document.createElement('script');
      script2.src = '//reporterlistedlipstick.com/9e8bb6172a4ce815606ae5e98c86e78b/invoke.js';
      script2.type = 'text/javascript';

      containerRef.current.innerHTML = '';
      containerRef.current.appendChild(script1);
      containerRef.current.appendChild(script2);
    }
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        textAlign: 'center',
        margin: '20px 0',
        display: window.innerWidth < 768 ? 'none' : 'block'
      }}
    />
  );
};

const AdsterraBannerMobile = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (window.innerWidth < 768 && containerRef.current) {
      const script1 = document.createElement('script');
      script1.innerHTML = `
        atOptions = {
          'key': '1809856d2ced015c814a3f17493c2673',
          'format': 'iframe',
          'height': 250,
          'width': 300,
          'params': {}
        };
      `;
      const script2 = document.createElement('script');
      script2.src = '//reporterlistedlipstick.com/1809856d2ced015c814a3f17493c2673/invoke.js';
      script2.type = 'text/javascript';

      containerRef.current.innerHTML = '';
      containerRef.current.appendChild(script1);
      containerRef.current.appendChild(script2);
    }
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        textAlign: 'center',
        margin: '20px 0',
        display: window.innerWidth >= 768 ? 'none' : 'block'
      }}
    />
  );
};


  return (
    <div>
      <Add scrollToCategory={scrollToCategory} />
      <Category scrollToCategory={scrollToCategory} />
      
      <div><HomeCardPro setIsLoading={setIsLoading} /></div>
      <div ref={categoryRefs.Car}><HomeCard setIsLoading={setIsLoading} /></div>
      <div><HomeCard9 setIsLoading={setIsLoading} /></div>
      <div><HomeCard10 setIsLoading={setIsLoading} /></div>

      <div ref={categoryRefs.Bikes}><HomeCard1 setIsLoading={setIsLoading} /></div>

      <div ref={categoryRefs.Property}><HomeCard2 setIsLoading={setIsLoading} /></div>

      <div ref={categoryRefs.Jobs}><HomeCard3 setIsLoading={setIsLoading} /></div>

      <div ref={categoryRefs.Mobile}><HomeCard4 setIsLoading={setIsLoading} /></div>

      <div ref={categoryRefs.Hostels}><HomeCard5 setIsLoading={setIsLoading} /></div>

      <div ref={categoryRefs.Electronics}><HomeCard6 setIsLoading={setIsLoading} /></div>

      <div ref={categoryRefs.Furniture}><HomeCard7 setIsLoading={setIsLoading} /></div>

      <div><HomeCard8 setIsLoading={setIsLoading} /></div>
      <AdsterraBannerPC />
    <AdsterraBannerMobile />

      <br />
      <br />
      <EndAdd />
      <br />
      <BannerAdd />
    </div>
  );
}
